import classnames from 'classnames';
import React from 'react';

import PropTypes from 'prop-types';

import { NotificationStore } from '../../../data/stores/NotificationStore';
import { NotificationActions as NotificationActionTypes } from '../../../data/constants/NotificationActions';
import { NotificationClientActionCreators as NotificationActions } from '../../../data/actions/NotificationClientActionCreators';

import { ROUTE_ACCOUNTS_UNKNOWN } from '../../../../ReduxStorage/routeActions';
import { NOTIFICATION_ICON_LOOKUP, PAGINATION_THRESHOLD } from './constants';

import { FontAwesome } from '../../../components/FontAwesome';
import { Timeago } from '../../../components/Timeago';
import { Spinner } from '../../../components/Spinner/Spinner';
import { Link } from '../../Link';

import { notifications } from '../styles.scss';

import './notifications-dropdown-contents.scss';

export const NotificationDropdownItem = ({ notification }) => {
  const icon = NOTIFICATION_ICON_LOOKUP[notification.action];
  return (
    <li role="menuitem">
      <a
        href={notification.link}
        data-notification-id={notification.id}
        className={classnames('notification-dropdown-item', {
          'notification-dropdown-item-read': !notification.isUnread(),
        })}
      >
        <img src={notification.image} alt={notification._raw.displayActors} />
        <div className="notification-preview">
          <span className="notification-details">
            {icon ? (
              <>
                <FontAwesome name={icon} />{' '}
              </>
            ) : null}
            {notification.messageComponents.map((item, itemIndex) => {
              const key = `${itemIndex}-${item.text}`;
              return (
                <span
                  key={key}
                  className={`notification-message-component notification-message-component-${item.format}`}
                >
                  {item.text}
                </span>
              );
            })}
          </span>

          <div className="notification-footer">
            {notification.isForCohort ? (
              <div className="notification-cohort">
                {notification.cohortString}
              </div>
            ) : null}
            <div className="notification-date">
              <Timeago time={notification.timestamp} />
            </div>
          </div>
        </div>
      </a>
    </li>
  );
};
NotificationDropdownItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  notification: PropTypes.object.isRequired,
};

export class NotificationsDropdownContents extends React.Component {
  state = {
    isLoadingNotifications: true,
    notificationsList: [],
  };

  componentDidMount() {
    NotificationStore.registerChangeCallback(this.update);
    this.update();
  }

  componentWillUnmount() {
    NotificationStore.unregisterChangeCallback(this.update);
  }

  update = () => {
    this.setState({
      isLoadingNotifications: NotificationStore.loadingMoreNotifications(
        NotificationActionTypes.ACTION_ALL,
        true
      ),
      notificationsList: NotificationStore.getNotifications(
        NotificationActionTypes.ACTION_ALL,
        true
      ),
    });
  };

  markAllAsRead = (event) => {
    event.preventDefault();
    NotificationActions.setAllNotificationsChecked();
  };

  scrollNotifications = ({ target }) => {
    const pixelsFromBottom =
      target.scrollHeight - target.scrollTop - target.clientHeight;
    if (pixelsFromBottom < PAGINATION_THRESHOLD) {
      if (
        !NotificationStore.loadingMoreNotifications(
          NotificationActionTypes.ACTION_ALL,
          true
        )
      ) {
        NotificationActions.loadMoreNotifications(
          NotificationActionTypes.ACTION_ALL,
          true
        );
      }
    }
  };

  render() {
    const { notificationsList, isLoadingNotifications } = this.state;
    return (
      <div
        // riot-tag attribute is used in CSS
        riot-tag="notifications-dropdown-contents"
        className={classnames(notifications)}
      >
        <section className="notifications-section">
          <ul
            className="notification-list"
            onScroll={this.scrollNotifications}
            role="menu"
          >
            {notificationsList.map((notification) => (
              <NotificationDropdownItem
                key={notification.id}
                notification={notification}
              />
            ))}
            {isLoadingNotifications ? (
              <li>
                <div className="notification-loading">
                  <span className="notification-loading-spinner">
                    <Spinner />
                  </span>
                  <span className="notification-loading-text">
                    Loading notifications
                  </span>
                </div>
              </li>
            ) : null}
          </ul>

          <ul className="notifications-dropdown-footer">
            <li>
              <button
                type="button"
                onClick={this.markAllAsRead}
                className="notifications-dropdown-footer-link"
              >
                Mark all as read
              </button>
            </li>
            <li>
              <Link
                to={{
                  type: ROUTE_ACCOUNTS_UNKNOWN,
                  params: {
                    subPath: 'notifications',
                  },
                }}
                className="notifications-dropdown-footer-link"
              >
                See all notifications
              </Link>
            </li>
          </ul>
        </section>
      </div>
    );
  }
}
